export type RuntimeConfig = {
  appName?: string;
  tenantAlias?: string;
  auth0Domain?: string;
  auth0ClientId?: string;
  stackEnvironment?: string;
  simulationSupersetApiUrl?: string;
  signozUrl?: string;
};

export function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__RUNTIME_CONFIG__ ?? {};
}

export function getRuntimeTenantAlias(): string | undefined {
  return getRuntimeConfig().tenantAlias;
}

export function getRuntimeStackEnvironment(): string | undefined {
  return getRuntimeConfig().stackEnvironment;
}

// Base URL of this stack's Superset instance (e.g. https://bmarni.simulation.supply-chain-planning.dev.ksai.cloud),
// set per-stack via SIMULATION_SUPERSET_API_URL (still browser-exposed despite the ApiUrl
// suffix used for proxied backend URLs elsewhere — see server/routes/runtimeConfig.ts).
// Undefined on any stack that hasn't opted into Superset (supersetEnabled: false in
// ksai-simulation-service-infra) — callers building a Superset link must treat that as
// "no link", not fall back to guessing a host.
export function getRuntimeSimulationSupersetApiUrl(): string | undefined {
  return getRuntimeConfig().simulationSupersetApiUrl;
}
